import React, { useState } from "react";
import useSWR from 'swr';
import fetcher from "../../utils/fetcher";
import NewsLetterCards from "../../components/NewsLetterCards";
import { Helmet } from "react-helmet";
import ModalBasic from "../../components/Modal";
import moment from "moment";
import 'moment/locale/ko';

const LoadMore = () => {
  const { data } = useSWR('https://api.testworks.co.kr/newsletters?_sort=set_day:DESC', fetcher);

  const postsPerPage = 5;
  const [next, setNext] = useState(postsPerPage);
  const handleMorePosts = () => {
    setNext(next + 5);
  };

  // 모달창 노출 여부 state
  const [modalOpen, setModalOpen] = useState(false);

  // 모달창 노출
  const showModal = () => {
      setModalOpen(true);
  };
  return (
    <>
      <Helmet>
        <title>에이아이웍스 – 에이아이웍스의 최신 소식</title>
        <meta name='description' content='에이아이웍스의 AI $ Data, Qaulity Validattion, Social Impact 최신소식을 살펴보세요.' />
      </Helmet>
      <div className="visualWrap newsLetterVisual">
        <div className="inner">
          <div className="tit_wrap">
            <div className="flex_col">
              <h2>Newsletter</h2>
              <p>AI & Data, Quality Validation, Social Impact 최신 소식</p>
            </div>
          </div>
            <button className="lp_open aBtn" onClick={showModal} style={{ display: 'none' }}>구독하기</button>
            {modalOpen && <ModalBasic setModalOpen={setModalOpen} />}
        </div>
      </div>
      <div className="newsLetter">
        <ul className="newsLetterTop">
          <li>
            <a href="https://www.aiworkx.ai/newsletter/Newsletter_Testworks_MKT%20202301%20(0111).html" target="_blank" rel='noreferrer'>
              <span>전문보기</span>
            </a>
          </li>
          <li>
            <a href="https://www.aiworkx.ai/newsletter/Newsletter_Testworks_MKT%20202212%20(1228).html" target="_blank" rel='noreferrer'>>
              <span>전문보기</span>
            </a>
          </li>
        </ul>
        {data ? (
          <div className="newsLetterList">
            {data && (
              data?.slice(0, next)?.map((post) => {
                if (post.showing) {
                  return (
                      <NewsLetterCards
                          key={post.id}
                          id={post.id}
                          to={post.link}
                          title={post.title}
                          date={moment(post.set_day).format('YYYY.MM.DD')}
                      />
                  )} else {
                  return null;
                }
              })
            )}
            {next < data?.length && (
              <button
                className="more"
                onClick={handleMorePosts}>
                더보기
              </button>
            )}
          </div>
        ) : (
          <div className="loading">Loading...</div>
        )}
      </div>
    </>
  )
}

export default LoadMore;